import { Input } from '@Backlot-Cars/archie';
import { RecaptchaV2 } from 'components/BlcRecaptcha';
import { forwardRef, useState } from 'react';

const Recaptcha = forwardRef((props, ref) => {
	const [shouldValidate, setShouldValidate] = useState(false);

	const onChangeRecaptcha = (value) => {
		props.setValue && props.setValue('recaptcha', value, { shouldValidate });
	};

	return (
		<>
			<RecaptchaV2
				onVerified={onChangeRecaptcha}
				onExpired={onChangeRecaptcha}
				onError={onChangeRecaptcha}
				onRender={() => {
					setShouldValidate(true);
				}}
				onLoaded={() => {
					setShouldValidate(true);
				}}
				{...props}
			/>
			<Input ref={ref} style={{ display: 'none' }} {...props} />
		</>
	);
});

Recaptcha.displayName = 'Recaptcha';

export default Recaptcha;
